import { InvalidateQueryFilters, QueryClient } from '@tanstack/react-query'
import { UseFormReset } from 'react-hook-form'

type Entity<IDKey extends keyof any, IDType> = {
    [key in IDKey]: IDType
}

interface DTO {}

interface FormHandlerProps<T extends Entity<IDKey, IDType>, D extends DTO, IDKey extends keyof T, IDType> {
    initialData?: T | null
    queryClient: QueryClient
    queryKey: string[]
    onClose?: () => void
    reset: UseFormReset<D>
    setLoading: (loading: boolean) => void
    createEntity: (data: D) => Promise<void>
    updateEntity: (id: IDType, data: D, partnerId?: string) => Promise<void>
    entityIdKey: IDKey
    partnerId?: string
}

export const handleFormSubmit = async <T extends Entity<IDKey, IDType>, D extends DTO, IDKey extends keyof T, IDType>(
    {
        initialData,
        queryClient,
        queryKey,
        onClose,
        reset,
        setLoading,
        createEntity,
        updateEntity,
        entityIdKey,
        partnerId,
    }: FormHandlerProps<T, D, IDKey, IDType>,
    data: D,
) => {
    setLoading(true)
    try {
        if (initialData && initialData[entityIdKey] !== undefined) {
            await updateEntity(initialData[entityIdKey], data, partnerId)
        } else {
            await createEntity(data)
        }
        onClose && onClose()
        reset()
        queryClient.invalidateQueries(queryKey as InvalidateQueryFilters)
    } catch (error) {
        throw error
    } finally {
        setLoading(false)
    }
}
